import React, {useContext} from "react"
import {LabelContext} from "../../assets/js/labelDataContext"
import DayPicker, {DateUtils} from "react-day-picker"
import "react-day-picker/lib/style.css"
import {Helmet} from "react-helmet"
import va from "simple-react-lightbox";

const MONTHS = [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
]
const WEEKDAYS_LONG = [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota",
]
const WEEKDAYS_SHORT = ["Niedz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"]

const OrderDate = props => {
    const value = useContext(LabelContext)
    const date = value.labelInfo.date
    const [isSaturdayCatering, setIsSaturdayCatering] = React.useState(value.labelInfo.isSaturdayCatering);
    const [isSundayCatering, setIsSundayCatering] = React.useState(value.labelInfo.isSundayCatering);
    const btnDisabled = date.from && date.to
    const modifiers = {
        start: date.from,
        end: date.to,
    }

    var disabledDays = [];

     function getSaturdaysInTwoMonths(startDate) {
    const result = [];
    let date = new Date(startDate.getTime());
    let startMonth = startDate.getMonth();


    while (date.getDay() !== 6) {
      date.setDate(date.getDate() + 1);
    }

    for (let i = 0; i < 4; i++) {
      while (date.getMonth() === (startMonth + i) % 12) {
        if (!isSaturdayCatering) {
          result.push(new Date(date.getTime()));
        }
        if (!isSundayCatering) {
          result.push(new Date(date.getTime() + 86400000));
        }
        date.setDate(date.getDate() + 7);
      }
    }

    return result;
  }

    const handleChangeIsSaturdayCatering = () => {
        let opIsSaturdayCatering = !isSaturdayCatering
        setIsSaturdayCatering(opIsSaturdayCatering);
        value.setIsSaturdayCatering(opIsSaturdayCatering)
        disabledDays = getSaturdaysInTwoMonths(new Date());
    };

    const handleChangeIsSundayCatering = () => {
        let opIsSundayCatering = !isSundayCatering;
        setIsSundayCatering(opIsSundayCatering);
        value.setIsSundayCatering(opIsSundayCatering)
        disabledDays = getSaturdaysInTwoMonths(new Date());
    };

    const handleDayClick = day => {
        if (value.labelInfo.dietDay == 2) {
            date.from = day;
            date.to = day;
            value.setDateInfo(date)
        } else {
            let dayToAdding = getCountDaysToAdd()
            let firstDayCatering = addDays(new Date(), dayToAdding)
            if (day <= firstDayCatering) day = firstDayCatering
            const range = DateUtils.addDayToRange(day, date)
            console.log(range)
            value.setDateInfo(range)
        }
    }

    const handleResetClick = () => {
        value.setDateInfo({
            from: undefined,
            to: undefined,
        })
    }

    const addDays = (date, days) => {
        const copy = new Date(Number(date))
        copy.setDate(date.getDate() + days)
        return copy
    }

    const isSuturaday = () => {
        return new Date().getDay() == 6
    }

    const getCountDaysToAdd = () => {
        return isSuturaday() ? 3 : 2
    }

  const [days, setDays] = React.useState([]);

  const footer =
    days && days.length > 0 ? (
      <p>You selected {days.length} day(s).</p>
    ) : (
      <p>Please pick one or more days.</p>
    );
        disabledDays = getSaturdaysInTwoMonths(new Date());

    return (
        <>
            <form>
                <div className="date-box">
                    <h4>Wybierz dni dostawy</h4>

                    <p>
                        {!date.from && !date.to && "Wybierz pierwszy dzień cateringu"}
                        {date.from && !date.to && "Wybierz ostani dzień cateringu "}
                        {date.from &&
                            date.to &&
                            `Catering od ${date.from.toLocaleDateString()} do ${date.to.toLocaleDateString()}`}
                        {isSuturaday() && (
                            <>
                                <br/>
                                <span className="text-danger">
                  Pierwszy możliwy dzień catetingu to wtorek.
                </span>
                            </>
                        )}
                    </p>

                    {date.from && date.to && (
                        <button className="clear-btn" onClick={handleResetClick}>
                            Wyczyść
                        </button>
                    )}

                    {value.labelInfo.dietDay == 2 &&
                        <div className="row">
                            <div className="col-6 w-100">
                                <span className="text-danger">
                                    Zestaw testowy można zamówić tylko jednorazowo.
                                </span>
                            </div>
                            </div>
                            }

                            {value.labelInfo.dietDay != 2 &&
                                <div className="row">
                                    <div className="col-6 w-100">
                                        <input type="checkbox"
                                               id="isSaturdayCatering"
                                               name="isSaturdayCatering"
                                               checked={isSaturdayCatering}
                                               onChange={handleChangeIsSaturdayCatering}/>
                                        <label htmlFor="isSaturdayCatering">Catering w soboty</label>
                                    </div>

                                    <div className="col-6 w-100">
                                        <input type="checkbox"
                                               id="isSundayCatering"
                                               name="isSundayCatering"
                                               checked={isSundayCatering}
                                               onChange={handleChangeIsSundayCatering}/>
                                        <label htmlFor="isSundayCatering">Catering w niedzele</label>
                                    </div>
                                </div>
                            }

                    <DayPicker
                        class="Selectable"
                        numberOfMonths={2}
                        selectedDays={[date.from, date]}
                        modifiers={modifiers}
                        onDayClick={handleDayClick}
                                disabledDays={[
                                    {
                                        before: addDays(new Date(), getCountDaysToAdd()),
                                        after: new Date(
                                            new Date().getFullYear(),
                                            new Date().getMonth(),
                                            0
                                        ),
                                    },
                                    {
                                        from: new Date('2024-12-24'),
                                        to: new Date('2025-1-2'),

                                    },
                                    
                                    // {
                                    //     from: new Date(2023, 12, 24), to: new Date(2024, 1, 2)
                                    // }
                                    // { daysOfWeek: [0, 6] }
                                ]}
                                months={MONTHS}
                                weekdaysLong={WEEKDAYS_LONG}
                                weekdaysShort={WEEKDAYS_SHORT}
                                firstDayOfWeek={1}
                            />
                            {/* <DayPicker
      mode="multiple"
      min={1}
      selected={days}
      onSelect={setDays}
      footer={footer}
    /> */}

                            <div
                                variant="contained"
                                color="primary"
                                aria-label="text primary button group"
                                style={{marginTop: 15}}
                            >
                                <button onClick={() => value.prevPage()} className="btn-next">
                                    Wstecz
                                </button>
                                <button
                                    disabled={!btnDisabled}
                                    onClick={() => value.nextPage()}
                                    className="btn-next"
                                >
                                    Dalej
                                </button>
                            </div>
                        </div>
                        </form>
                        </>
                        )
                    }
                    export default OrderDate
